import { wishList } from './wishlist';
import { getCart } from '../services/cart-api';

// close sidecart clicking outside or on close button
const closeSideCart = () => {
  const cartDrawer = document.querySelector('.mini-cart-content');
  const cartOverlay = document.querySelector('.overlaycart');
  if (!cartDrawer) return;

  document.querySelector('body').addEventListener('click', (event) => {
    if (cartDrawer.classList.contains('active')) {
      
      const isCloseButton = event.target.closest('.mini-cart-close');
      const isOpenButton = event.target.closest('.header-menu__action--cart') || 
                          event.target.closest('#CartDrawerMobile');
      
      if ((event.target === cartOverlay || isCloseButton) && !isOpenButton) {
        cartDrawer.classList.remove('active');
        cartOverlay.classList.remove('active');
        document.body.classList.remove('no-scroll');
        document.body.classList.remove('cart-open-mobile');
      }
    }
  });
}

const shouldOpenSideCart = () => {
  const miniCartToggle = document.querySelector('.js-mini-cart');
  return miniCartToggle?.getAttribute('data-cartmini') === 'true';
};

const openSideCart = () => {
  const cartDrawer = document.querySelector('.mini-cart-content');
  const cartOverlay = document.querySelector('.overlaycart');
  if (!cartDrawer || !cartOverlay) return;
  if (!shouldOpenSideCart()) return;
  cartDrawer.classList.add('active');
  cartOverlay.classList.add('active');
  document.body.classList.add('no-scroll');
  if (window.matchMedia('(max-width: 767px)').matches) {
    document.body.classList.add('cart-open-mobile');
  }
};

/**
 * Initializes the redesigned side cart by removing old elements and updating item count.
 * Listens for cart toggle events to refresh cart data dynamically.
 * Ensures wishlist functionality is initialized when the cart opens.
 */
const initSideCartRedesign = async () => {
  document.addEventListener('pdm-cart-toggle', event => {
    const isCartOpenTriggered = event.detail.isCartOpen;

    if (isCartOpenTriggered) {
      const itemCount = document.querySelector('.mini-cart-content .mini-cart-heading__items-count');
      if (itemCount) {
        setTimeout(async () => {
          wishList(); 
    
          const cartObject = await getCart();
          if (cartObject.status) {
            itemCount.textContent = `(${cartObject.response.item_count})`;
          } 
        }, 1000);
      }
    }    
  });
}

const clickOpenSidecart = () => {
  const cartIcon = document.querySelector('.header-menu__action--cart');
  const cartIconMobile = document.querySelector('#CartDrawerMobile');
  const cartDrawer = document.querySelector('.mini-cart-content');
  const cartOverlay = document.querySelector('.overlaycart');

  const openCart = (event) => {
    cartDrawer.classList.add('active');
    cartOverlay.classList.add('active');
    document.body.classList.add('no-scroll');
    if (window.matchMedia('(max-width: 767px)').matches) {
      document.body.classList.add('cart-open-mobile');
    }
  };

  // Desktop cart icon
  if (cartIcon && cartDrawer) {
    cartIcon.addEventListener('click', openCart);
  }

  // Mobile cart icon
  if (cartIconMobile && cartDrawer) {
    cartIconMobile.addEventListener('click', openCart);
  }
}

/**
 * Initializes the event listener for the sidecart closing behavior.
 *
 * @function initializeSideCartListener
 */
const initializeSideCartListener = () => {
  closeSideCart();
  initSideCartRedesign();
  clickOpenSidecart();

  document.addEventListener('pdm-add-to-cart', () => {
    openSideCart();
  });
};

export default initializeSideCartListener;
